import { Link, useLocation } from "react-router-dom";
import { useLanguage } from "../../context/LanguageContext";
import layoutLanguage from "../../language/layoutLanguage";
import { authAPI } from "../../services/api";

export default function WebLayout() {

  const location = useLocation();
  const currentPath = location.pathname;

  const { language } = useLanguage();
  const text = layoutLanguage[language];

  const currentUser = authAPI.getCurrentUser();
  const permissions = currentUser?.permissions;

  const hasPermission = (code) => {
    if (!permissions || permissions.length === 0) return false;
    return permissions.includes(code);
  };

  const hasAnySettingsPermission = () => {
    if (!permissions || permissions.length === 0) return false;
    return permissions.some(p => p.startsWith("SETTINGS."));
  };

  const isActive = (path) => {
    if (path === "/settings") {
      return currentPath.startsWith("/settings");
    }
    return currentPath === path;
  };
  const isReportModuleActive =
    currentPath === "/report" || currentPath === "/bill";

  const activeClass = "sidebar-icon-item active";
  const inactiveClass = "sidebar-icon-item";

  return (
    <>
      <div className="web-sidebar">
        <div className="app-logo mb-6">
          <img
            src="/images/logo.png"
            alt={text.appTitle}
            width="120"
            height="105"
            className="mx-auto"
          />
        </div>

        <h1 className="page-title text-xl font-bold text-slate-900 dark:text-white mb-4 text-center">
          {text.appTitle}
        </h1>

        <div className="stats-container mb-8" style={{ display: "none" }}>
          <div className="stats-title">{text.totalCustomersTitle}</div>
          <div className="stats-value">5</div>
        </div>

        <nav className="space-y-2 mt-2">
          {hasPermission("HOME") && (
            <Link
              to="/"
              className={`${isActive("/") ? activeClass : inactiveClass}`}
            >
              <i className="fas fa-home" />
              <span>{text.navHome}</span>
            </Link>
          )}

          {hasPermission("DASHBOARD") && (
            <Link
              to="/dashboard"
              className={isActive("/dashboard") ? activeClass : inactiveClass}
            >
              <i className="fas fa-chart-line" />
              <span>{text.navDashboard}</span>
            </Link>
          )}

          {(hasPermission("REPORT.REPORT") || hasPermission("REPORT.BILL")) && (
            <Link
              to="/report"
              className={isReportModuleActive ? activeClass : inactiveClass}
            >
              <i className="fas fa-file-alt" />
              <span>{text.navReport}</span>
            </Link>
          )}

          <Link
            to="/settings"
            className={isActive("/settings") ? activeClass : inactiveClass}
          >
            <i className="fas fa-ellipsis-h" />
            <span>{text.navSettings}</span>
          </Link>
        </nav>
      </div>
    </>
  );
}
